/* eslint-disable @typescript-eslint/no-explicit-any */

interface IAddressDto {
    longitude?: string;
    latitude?: string;
    addressLine1?: string;
    addressLine2?: string;
    country?: string;
    city?: string;
    postalCode?: string;
    state?: string;
}

export interface IUpdateAccountSettingDto {
    id: string;
    name: string;
    timezone?: string;
    photo?: any;
    address?: IAddressDto;
}
